import { withStyles, createStyles, Theme, Box } from "@material-ui/core";

export const Separator = withStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 1,
      backgroundColor: "white",
      width: `calc(100% + ${theme.spacing(5)}px)`,
      marginLeft: -theme.spacing(2.5),
      marginTop: theme.spacing(2),
    },
  }),
)(Box);
